import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoaderCstm from "../../../components/Loader";
import { loginWithEmail } from "../../../lib/store/actions";
import styles from "../../../components/Layout/Authlayout/Authe.module.scss";
import { useGameContext } from "../../../context/GameContext";

const Signin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector(({ Auth }) => Auth);
  const { setGame, setGameStart, setGameLoading } = useGameContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const activeGameDetail = (userData) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (
          (userData?._id && !userData?.currentGame?._id) ||
          !userData?._id ||
          !userData?.currentGame?._id
        ) {
          setTimeout(() => {
            setLoader(false);
            setGameLoading(false);
            resolve();
          }, 2000);
          return;
        }

        setLoader(true);
        let updatedData = {
          ...userData?.currentGame,
          gameData: [],
          lineData: [],
        };
        updatedData = {
          ...updatedData,
          gameData: userData?.currentGame?.gameData,
          lineData: userData?.currentGame?.lineData,
          winnings: updatedData?.winnings?.length
            ? [...updatedData.winnings]
            : [],
        };
        setGame({
          ...updatedData,
          gameData: updatedData?.gameData?.reverse(),
          lineData: updatedData?.lineData?.reverse(),
        });

        setTimeout(() => {
          setLoader(false);
          setGameLoading(false);
          resolve(updatedData);
          setGameStart(true);
        }, 1000);
      } catch (err) {
        setLoader(false);
        setGameLoading(false);
        reject(err);
      }
    });
  };

  const onClickSignIn = async () => {
    setError(null);

    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }
    setLoader(true);
    dispatch(
      loginWithEmail({
        data: { email, password },
        callBack: async (err, res) => {
          if (parseInt(err?.status_code) === 406) {
            setLoader(false);
            return navigate("/maintenance");
          }
          if (err) {
            setError(err.message || "Failed to verify OTP.");
            setLoader(false);
            return;
          } else {
            await activeGameDetail(res);
            setTimeout(() => {
              setLoader(false);
              navigate("/game");
            }, 3000);
          }
        },
      }),
    );
  };

  return (
    <>
      {loader || loading ? (
        <div className="d-flex justify-content-center my-3">
          <LoaderCstm />
        </div>
      ) : (
        <div className="formBody">
          <Form>
            <div className="py-2">
              <label
                htmlFor="email"
                className="form-label m-0 text-white w-100 text-start"
              >
                Enter Email
              </label>
              <input
                id="email"
                type="email"
                placeholder="Enter Email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="py-2">
              <label
                htmlFor="password"
                className="form-label m-0 text-white w-100 text-start"
              >
                Password
              </label>
              <div className="iconWithText position-relative">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="*******"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
                <button
                  className="position-absolute icn border-0 p-0 bg-transparent"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                  style={{
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: 10,
                  }}
                >
                  <i
                    className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                  ></i>
                </button>
              </div>
            </div>

            {error && <div className="text-danger py-2">{error}</div>}

            <div className="py-2">
              <Button
                style={{ maxWidth: 250 }}
                className={`${styles.telegramBtn} mx-auto rounded-pill w-100 d-flex px-4 align-items-center justify-content-center mt-2`}
                onClick={onClickSignIn}
                disabled={loading}
              >
                Sign In
              </Button>
            </div>
          </Form>

          <div>
            <p className="m-0 py-2 text-white mt-2">
              Don't have an account?{" "}
              <Link to={"/sign-up"} className="themeClr fw-sbold">
                Sign Up With Email
              </Link>
            </p>
          </div>
        </div>
      )}
    </>
  );
};
export default Signin;
